<template>
  <div class="flex flex-col gap-6 w-full h-full">
    <loading-overlay v-if="loading" :value="loading" />
    <div v-else class="block-container">
      <BaseTabs :tabs="tabs" :active-tab="activeTab" @change:tab="changeTab">
      </BaseTabs>
    </div>

    <component
      ref="activeselectedItem"
      :is="currentTabComponent"
      :selectedItem="selectedItem"
      :items="items"
      :selected-item="selectedItem"
      :loading="loading"
      :total="total"
      :pagination="pagination"
      @row-click="$emit('row-click', $event)"
      @edit="$emit('edit', $event)"
      @exclude="$emit('exclude', $event)"
      @delete="$emit('delete', $event)"
      @page-change="$emit('page-change', $event)"
      @add-child="$emit('add-child', $event)"
      class="flex-1 w-full h-full"
    />
  </div>
</template>

<script>
import LoadingOverlay from "@/shared/ui/custom/components/LoadingOverlay.vue";
import BaseTabs from "@/shared/ui/custom/tabs/BaseTabs.vue";
import DirectoryData from "./tabs/DirectoryData.vue";
import ReferenceHistory from "./tabs/ReferenceHistory.vue";

import DirectoryChildrenTable from "@/pages/admin/references2/tabs/DirectoryChildrenTable.vue";

export default {
  name: "ReferenceItem",
  props: {
    selectedItem: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      default: () => [],
    },
    total: {
      type: Number,
      default: 0,
    },
    pagination: {
      type: Object,
      default: () => ({
        page: 1,
        size: 20,
      }),
    },
  },
  components: {
    LoadingOverlay,
    BaseTabs,
    DataReference: DirectoryData,
    ReferenceHistory,
    DirectoryChildrenTable,
  },

  data() {
    return {
      loading: false,
      loader: false,

      activeTab: "data",
      tabs: {
        data: {
          label: this.$t("Данные"),
          icon: "huge-text-config",
        },

        reference_value: {
          label: this.$t("Значения справочника"),
          icon: "huge-text-config",
        },
        history: {
          label: this.$t("История"),
          icon: "huge-history",
        },
      },
    };
  },

  computed: {
    currentTabComponent() {
      const tabComponents = {
        data: DirectoryData,
        history: ReferenceHistory,
      };

      return tabComponents[this.activeTab] || DirectoryChildrenTable;
    },
  },

  watch: {
    "$route.query.tab": {
      immediate: true,
      handler(tab) {
        if (tab) {
          this.activeTab = tab;
        }
      },
    },
  },

  methods: {
    changeTab(tab) {
      this.$router.replace({
        query: {
          ...this.$route.query,
          tab,
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.button {
  @apply h-10 flex justify-center items-center p-4 bg-card border;
  @apply border-border rounded outline-none;
  &:active {
    transselecteditem: scale(0.98);
  }
}

.menu {
  @apply w-[282px] flex flex-col p-2 gap-2 bg-card rounded-xl outline outline-1 outline-offset-[-1px];
}

.item {
  @apply flex items-center px-3 py-2 gap-3 rounded-lg cursor-pointer transition-colors;
  svg {
    @apply text-foreground;
    &.danger {
      @apply text-red-400;
    }
  }

  span {
    @apply text-base font-medium leading-6 text-foreground;
    &.danger {
      @apply text-red-400;
    }
  }
}
</style>
